import { render, staticRenderFns } from "./ConfigSMTP.vue?vue&type=template&id=67bf4a6d&scoped=true"
import script from "./ConfigSMTP.vue?vue&type=script&lang=js"
export * from "./ConfigSMTP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bf4a6d",
  null
  
)

export default component.exports